module.exports = __webpack_public_path__ + "img/w3_copy_black.02475705.png";